
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/brew-guides/[slug]",
      function () {
        return require("private-next-pages/[region]/[lang]/brew-guides/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/brew-guides/[slug]"])
      });
    }
  